import appConfig from "../../../app.config";

import { useAppDispatch } from '../../state/hooks';
import { show as showTour } from '../../slices/local/tour';
import { t } from "i18next";
import SentryFeedbackButton from "../partials/SentryFeedbackButton";

export const CompanyInner = () => {
  const dispatch = useAppDispatch();

  return (
    <div className="md:flex md:flex-row lg:items-center lg:justify-between font-minion">
      <div className="flex-1">
        <h3 className="text-sm font-semibold leading-5 text-white tracking-wider">
          Radiopark GmbH & Co. KG
        </h3>
        <p className="text-sm leading-5 text-gray-300">
          Große Bleichen 21, 20354 Hamburg, Germany
        </p>
        <p className="text-sm leading-5 text-gray-300">
          +49 89 69 39 58 0 | <a href="mailto:support@radiopark.de" className="cursor-pointer underline text-yellow">support@radiopark.de</a> | <a href="https://radiopark.de" className="cursor-pointer underline text-yellow" target="_blank">radiopark.de</a>
        </p>
      </div>
      <div className="mt-4 rounded-md sm:mt-0 sm:ml-4 sm:shrink-0 flex flex-col justify-center gap-1 md:mb-2">
        <div className="flex flex-row gap-2">
          {appConfig.showOnboarding && (
            <a className="flex w-full items-center justify-center border-yellow border-4 py-1.5 px-3 text-base font-semibold leading-7 text-yellow hover:bg-yellow hover:text-dark sm:text-sm sm:leading-6 text-nowrap" role="button" onClick={() => dispatch(showTour())}>
              {t('footer.tour_guide')}
            </a>
          )}
          {appConfig.sentry.enabled && (
          <SentryFeedbackButton className="flex items-center justify-center border-yellow border-4 py-1.5 px-3 text-base font-semibold leading-7 text-yellow hover:bg-yellow hover:text-dark sm:text-sm sm:leading-6 text-nowrap" />
          )}
        </div>
        <div className="flex justify-end md:absolute bottom-0 right-0">
          <span className="text-xs text-gray-300">{process.env.REACT_APP_VERSION} ({process.env.REACT_APP_COMMIT_HASH})</span>
        </div>
      </div>

    </div>
  );
};
